import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../../api/axios';
import PasswordInput from '../../components/PasswordInput';

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ password: '', confirmPassword: '' });
  const [loading, setLoading] = useState(false);
  const [complete, setComplete] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (form.password !== form.confirmPassword) return toast.error('Passwords do not match');
    setLoading(true);
    try {
      const { data } = await api.put(`/auth/reset-password/${token}`, { password: form.password });
      setComplete(true);
      toast.success(data.message);
      setTimeout(() => navigate('/login'), 1800);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Could not reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] bg-[#FAF8F5] px-4 py-14 text-[#2B1810]">
      <div className="mx-auto max-w-md">
        <div className="mb-7 text-center">
          <p className="text-[10px] font-bold uppercase text-[#9D772D]">Account security</p>
          <h1 className="mt-2 font-heading text-4xl font-semibold">Create a new password</h1>
          <p className="mt-2 text-xs text-[#76675E]">Use at least eight characters.</p>
        </div>

        <div className="rounded-md border border-[#E8DFD8] bg-white p-7 shadow-sm">
          {complete ? (
            <div className="text-center">
              <div className="mx-auto grid h-11 w-11 place-items-center rounded-full bg-[#EEF4EE] text-xl text-[#34704A]">&#10003;</div>
              <h2 className="mt-4 font-heading text-2xl font-semibold">Password updated</h2>
              <p className="mt-2 text-xs text-[#76675E]">Taking you to login...</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div><label className="label">New password</label><PasswordInput required autoFocus minLength="8" autoComplete="new-password" value={form.password} onChange={(event) => setForm({ ...form, password: event.target.value })} /></div>
              <div><label className="label">Confirm new password</label><PasswordInput required minLength="8" autoComplete="new-password" value={form.confirmPassword} onChange={(event) => setForm({ ...form, confirmPassword: event.target.value })} /></div>
              <button disabled={loading} className="w-full rounded bg-[#C49A45] py-3 text-xs font-bold uppercase text-white hover:bg-[#B08736] disabled:opacity-60">{loading ? 'Updating...' : 'Reset password'}</button>
            </form>
          )}
          <Link to="/login" className="mt-6 block border-t border-[#EEE7E1] pt-5 text-center text-[10px] font-bold uppercase text-[#76675E] hover:text-[#9D772D]">Back to login</Link>
        </div>
      </div>
    </div>
  );
}
